import React from "react";
import { Checkbox } from "../../../components/Checkbox";

// Column-type entries only (see 058_field_mapping_timestamp_format.sql's
// validate_field_mappings() trigger — static entries cannot carry a format
// at all). event_timestamp-shaped source columns are already stored as UTC;
// this is about the WIRE FORMAT some platforms expect, not a timezone
// conversion. Scoped per mapping entry since different fields even within
// the same job can need different formats.
const FORMAT_OPTIONS = [
  { value: "", label: "No formatting (raw value)" },
  { value: "iso8601", label: "ISO 8601" },
  { value: "iso8601_z", label: "ISO 8601, UTC (Z suffix)" },
  { value: "unix_seconds", label: "Unix timestamp (seconds)" },
  { value: "date_only", label: "Date only (YYYY-MM-DD)" },
  { value: "datetime_space", label: "Date + time (YYYY-MM-DD HH:mm:ss)" },
];

// One row inside MappedFieldsList — either a "column" mapping (source column
// -> editable target key, optional timestamp format) or a "static"/custom
// row (editable key + value).
export function MappedFieldRow({ mapping, error, onUpdate, onRemove }) {
  const isStatic = mapping.type === "static";
  const inputStyle = {
    background: "#FFFFFF",
    border: `1px solid ${error ? "#e53935" : "#E2E2E2"}`,
    borderRadius: 8,
    padding: "8px 10px",
    fontSize: 13,
    color: "#151515",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  };

  return (
    <div style={{ background: "#FFFFFF", border: "1px solid #E2E2E2", borderRadius: 10, padding: "10px 12px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <span
          style={{
            fontSize: 12, padding: "2px 7px", borderRadius: 20, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase",
            background: isStatic ? "#EEF2FF" : "#F5F5F5",
            color: isStatic ? "#323084" : "#7b7b7b",
          }}
        >
          {isStatic ? "Custom" : "Column"}
        </span>
        {!isStatic && <span style={{ fontSize: 12, color: "#7b7b7b" }}>{mapping.source_column}</span>}
        <button
          type="button"
          onClick={() => onRemove(mapping.rowId)}
          aria-label={`Remove field ${mapping.target_key || ""}`}
          style={{ marginLeft: "auto", background: "none", border: "none", color: "#7b7b7b", cursor: "pointer", fontSize: 14, lineHeight: 1 }}
        >
          ×
        </button>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 120 }}>
          <input
            type="text"
            aria-label="Target key"
            placeholder="target_key"
            value={mapping.target_key}
            autoFocus={!isStatic && !mapping.target_key}
            onChange={(e) => onUpdate(mapping.rowId, { target_key: e.target.value })}
            style={inputStyle}
          />
        </div>
        {isStatic && (
          <div style={{ flex: 1, minWidth: 120 }}>
            <input
              type="text"
              aria-label="Static value"
              placeholder="value"
              value={mapping.value}
              onChange={(e) => onUpdate(mapping.rowId, { value: e.target.value })}
              style={inputStyle}
            />
          </div>
        )}
        {!isStatic && (
          <div style={{ flex: 1, minWidth: 180 }}>
            <select
              aria-label="Format"
              value={mapping.format || ""}
              onChange={(e) => onUpdate(mapping.rowId, { format: e.target.value || undefined })}
              style={{ ...inputStyle, paddingRight: 32 }}
            >
              {FORMAT_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        )}
      </div>
      {!isStatic && (
        <label style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8, fontSize: 13, color: "#626262", cursor: "pointer" }}>
          <Checkbox
            checked={!!mapping.ah_prefix}
            onChange={(e) => onUpdate(mapping.rowId, { ah_prefix: e.target.checked || undefined })}
          />
          Add "ah-" prefix
        </label>
      )}
      {!isStatic && (
        <label style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6, fontSize: 13, color: "#626262", cursor: "pointer" }}>
          <Checkbox
            checked={!!mapping.random_suffix}
            onChange={(e) => onUpdate(mapping.rowId, { random_suffix: e.target.checked || undefined })}
          />
          Append random suffix
        </label>
      )}
      {error && <div style={{ color: "#e53935", fontSize: 13, marginTop: 6 }}>{error}</div>}
    </div>
  );
}
